import { isEmpty } from "lodash";
import type {
	IChecklistStatusResponse,
	PfsNonContainerProjectPayload,
	PfsNonContainerProjectResponse,
	ProductScoreResponse,
	ProductScoreResponseMultiple,
} from "../constants/pfsContants";
import Env from "../utils/env";
import { getUri, postUri } from "../utils/fetch";
import { getTaticIdObj } from "../utils/getTaticIdObj";

// GETs the checklist Status by product id
export const getChecklistStatus = (id: string): Promise<IChecklistStatusResponse> => {
	const uri = `${Env.pfsCsApiUrl}/product-listings/id/${id}/checklist/status`;
	return getUri(uri);
};

export const getProductScoreStatus = (id: string, abortSignal?: AbortSignal): Promise<ProductScoreResponse> => {
	const uri = `${Env.pfsCsApiUrl}/product-listings/id/${id}/score`;
	const additionalParams: RequestInit = {};
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	return getUri(uri, additionalParams);
};

export const getProductScores = (ids: string[], abortSignal?: AbortSignal): Promise<ProductScoreResponseMultiple[]> => {
	const uri = `${Env.pfsCsApiUrl}/product-listings/score`;
	const additionalParams: RequestInit = {};
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	const payload = { productListingIds: [...ids] };
	return postUri(uri, payload, additionalParams);
};

//Creates the RHEL or OpenStack non container project
export const createPfsNonContainerProject = (
	payload: PfsNonContainerProjectPayload,
): Promise<PfsNonContainerProjectResponse> => {
	const uri = `${Env.ConnectPortalUrls[Env.getEnvName()]}${Env.pfsAPIPrefix}`;
	return postUri(uri, payload);
};

// Sends tatic Ids
export const syncTaticIds = (
	certificationProjectId: string,
	status: "CERTIFICATION_STATUS_STARTED" | "CERTIFICATION_STATUS_ARCHIVED",
): void => {
	const uri = `${Env.pfsPsApiUrl}/partners/events/sync`;
	const taticIds = getTaticIdObj();
	const payload = {
		certificationProjectId,
		status,
		...taticIds,
	};
	if (!isEmpty(taticIds)) {
		void postUri(uri, payload);
	}
};
